import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { EntraAuthProvider, EntraLoginButton, useEntraAuth, EntraAuthStatus } from '../components/EntraAuth';
import { Card } from '../components/ui';
import './Login.css';

const LoginContent = () => {
    const navigate = useNavigate();
    const { isAuthenticated } = useEntraAuth();

    // State for messages
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    // Redirect if already authenticated (but allow showing success message first)
    useEffect(() => {
        const token = localStorage.getItem('token');
        const user = localStorage.getItem('user');

        // Show success message when authentication is detected
        if (token && user && !success) {
            setSuccess('Autentificare Microsoft reușită!');
            const userData = JSON.parse(user);
            // Add a small delay to show the success message
            setTimeout(() => {
                if (userData.role === 'doctor') {
                    navigate('/doctor-admin');
                } else {
                    navigate('/');
                }
            }, 2000); // Give user time to see success message
        }
    }, [navigate, isAuthenticated, success]);

    // Handle Entra ID login success
    const handleEntraLoginSuccess = (data) => {
        setSuccess('Autentificare Microsoft reușită!');
        // Success message will show, then useEffect will handle redirect after 2 seconds
    };

    // Handle Entra ID login error
    const handleEntraLoginError = (error) => {
        console.error('Entra login failed:', error);
        setError('Eroare la autentificarea Microsoft. Încercați din nou.');
    };

    return (
        <div className="login-container">
            <div className="login-card">
                <div className="login-header">
                    <Link to="/" className="home-link" title="Înapoi la pagina principală">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <polyline points="9,22 9,12 15,12 15,22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </Link>
                    <h1>Evoo Medical</h1>
                    <p>Autentificați-vă în cont</p>
                </div>

                {error && (
                    <Card
                        style={{
                            backgroundColor: 'var(--color-error)',
                            color: 'white',
                            marginBottom: 'var(--spacing-lg)',
                            border: 'none'
                        }}
                    >
                        {error}
                    </Card>
                )}
                {success && (
                    <Card
                        style={{
                            backgroundColor: 'var(--color-success)',
                            color: 'white',
                            marginBottom: 'var(--spacing-lg)',
                            border: 'none'
                        }}
                    >
                        {success}
                    </Card>
                )}

                {/* Microsoft Authentication Status */}
                <EntraAuthStatus />

                {/* Microsoft Entra ID Login */}
                <div className="auth-section">
                    <h3>Autentificare Evoo Medical</h3>
                    <p className="auth-description">
                        Conectați-vă cu contul dumneavoastră Microsoft pentru a accesa serviciile medicale.
                    </p>
                    <EntraLoginButton
                        onLoginSuccess={handleEntraLoginSuccess}
                        onLoginError={handleEntraLoginError}
                    />
                </div>

                {/* Information section */}
                <div className="login-info">
                    <h4>Informații despre autentificare:</h4>
                    <ul>
                        <li><strong>Medici și angajați:</strong> Folosiți autentificarea Microsoft pentru acces securizat la sistemul medical</li>
                        <li><strong>Pacienți:</strong> Pentru programări online, contactați clinica pentru asistență</li>
                    </ul>
                    <p className="login-note">
                        Dacă întâmpinați probleme cu autentificarea, contactați administratorul sistemului.
                    </p>
                </div>
            </div>
        </div>
    );
};

const Login = () => {
    return (
        <EntraAuthProvider>
            <LoginContent />
        </EntraAuthProvider>
    );
};

export default Login;
